<div class="container">
  <div class="my-5">
    <ul id="icons-list" class="row row-cols-3 row-cols-sm-4 row-cols-lg-6 row-cols-xl-8 list-unstyled list">
      <li *ngFor="let item of especialidadesVisibles" class="col mb-4" data-name="0-circle" data-tags="number numeral" data-categories="shapes">
        <a routerLink="/especialidades/{{item.especialidad}}" class="d-block text-body-emphasis text-decoration-none" >
          <div class="px-3 py-4 mb-2 bg-body-tertiary text-center rounded">
            <img src="{{serverImgenUrl}}{{item.icono}}" style="width: 50px; height: 50px"  class="img-fluid" alt="">
          </div>
          <div class="name text-muted text-decoration-none text-center pt-1">{{item.especialidad}}</div>
        </a>
      </li>
    </ul>
  </div>
</div>


